import {
	ModuleRegistry,
	provideGlobalGridOptions,
	themeMaterial,
} from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import {
	assetChipPart,
	crewChipPart,
	infoCellPart,
	labTableParts,
	monthReportCellPart,
	shiftChipPart,
	warningCellPart,
} from "./styles/ag-grid-parts";

const licenseKey = import.meta.env.VITE_AG_GRID_LICENSE;
LicenseManager.setLicenseKey(licenseKey);

const themeDXT = themeMaterial
	.withPart(warningCellPart)
	.withPart(infoCellPart)
	.withPart(monthReportCellPart)
	.withPart(assetChipPart)
	.withPart(labTableParts)
	.withPart(shiftChipPart)
	.withPart(crewChipPart)
	.withParams({
		spacing: 4,
	});

ModuleRegistry.registerModules([AllEnterpriseModule]);

provideGlobalGridOptions({
	theme: themeDXT,
	defaultColDef: {
		suppressHeaderMenuButton: true,
		filter: false,
		floatingFilter: false,
		editable: false,
		cellStyle: {
			textAlign: "center",
		},
	},
});
